import CmsService from "./cms.service";
import qs from 'qs'

const SiteService = {
    getHomePage: async function() {
        const query = qs.stringify({
            populate: {
                call_to_actions: {
                    populate: '*'
                },
                blockAboutImage: {
                    populate: '*'
                },
                faqs: {
                    populate: '*'
                },
                testimonials: {
                    populate: '*'
                },
                learn_mores: {
                    populate: '*'
                }
            }
        })
        const response = await CmsService.get(`home?${query}`);
        return response.data.data;
    },
    getHomePage2: async function() {
        const query = qs.stringify({
            populate: '*'
        })

        const response = await CmsService.get(`home?${query}`);

        return response.data.data;
    },
    getPartnerWithUsPage: async function() {
        const query = qs.stringify({
            populate: {
                testimonials: {
                    populate: '*'
                },
                property_partner_listing_icons: {
                    populate: '*'
                },
                property_partner_pricing_cards: {
                    populate: '*'
                },
                partnerSteps: {
                    populate: '*'
                },
                propertyLogos: {
                    populate: '*'
                },
            }
        })
        const response = await CmsService.get(`partner-with-us?${query}`);
        return response.data.data;
    },
    getPartnerWithUsSchoolPage: async function() {
        const query = qs.stringify({
            populate: {
                aboutBlocks: { populate: '*' },
                steps: { populate: '*' },
                schoolLogos: { populate: '*' },
                testimonials: { populate: '*' },
                partnerSteps: { populate: '*' },
            },
        });
        const response = await CmsService.get(`partner-with-us-school?${query}`);
        return response.data.data;
    },
    getAboutPage: async function() {
        const query = qs.stringify({
            populate: '*'
        })
        const response = await CmsService.get(`about?${query}`);
        return response.data.data.attributes;
    },
    getTermsPage: async function() {
        const response = await CmsService.get('term');
        return response.data.data;
    },
    getPolicyPage: async function() {
        const response = await CmsService.get('policy');
        return response.data.data;
    },
    getThankYouPage: async function() {
        const response = await CmsService.get('thank-you');
        return response.data.data;
    },
    getPosts: async function() {
        const query = qs.stringify({
            populate: '*'
        })
        const response = await CmsService.get(`posts?${query}`);
        return response.data.data;
    },
    getAuthors: async function() {
        const query = qs.stringify({
            populate: '*'
        })
        const response = await CmsService.get(`authors?${query}`);
        return response.data.data;
    },
    getMyFundsPage: async function() {
        const query = qs.stringify({
            populate: '*'
        })
        const response = await CmsService.get(`my-fund?${query}`);
        return response.data.data;
    },
    getRoommatesPage: async function() {
        const query = qs.stringify({
            populate: '*'
        })

        const response = await CmsService.get(`roommate?${query}`);
        return response.data.data;
    },
    getPropertiesPage: async function() {
        const query = qs.stringify({
            populate: '*'
        })

        const response = await CmsService.get(`property?${query}`);
        return response.data.data;
    },
    getLogos: async function() {
        const query = qs.stringify({
            populate: '*'
        })
        const response = await CmsService.get(`school-logos?${query}`);
        return response.data;
    },
    getCityImages: async function() {
        const query = qs.stringify({
            populate: '*'
        })
        const response = await CmsService.get(`city-images?${query}`);
        return response.data.data;
    },
    getAreaGuidePage: async function(pageSlug = null) {
        const filters = {};
       if (pageSlug) {
           filters.pageSlug = {
               $eq: pageSlug,
           };
       }

        const query = qs.stringify({
            filters,
            populate: {
                activities: { populate: ['image'] },
                downloadFile: '*',
                downloadPreview: '*',
                eateries: { populate: ['image'] },
                outings: '*',
                outingsImage: '*',
                tours: { populate: ['image'] },
            },
        });
        const response = await CmsService.get(`area-guides?${query}`);
        return response?.data?.data || null;
    },
    getBadgesPage: async function(badgeType = null) {
        let pageUrl;

        if (badgeType === 'property') {
            pageUrl = 'partner-property-badge';
        } else if (badgeType === 'school') {
            pageUrl = 'partner-school-badge';
        } else {
            return null;
        }

        const query = qs.stringify({
            populate: {
                badgeColorSmall: '*',
                badgeBlackSmall: '*',
                badgeWhiteSmall: '*',
                badgeColorLarge: '*',
                badgeBlackLarge: '*',
                badgeWhiteLarge: '*',
            },
        });
        const response = await CmsService.get(`${pageUrl}?${query}`);
        return response?.data?.data || null;
    },
    getHousingLandingPage: async function (pageSlug) {
        const filters = {};
        if (pageSlug) {
            filters.pageSlug = {
                $eq: pageSlug,
            };
        }

        const query = qs.stringify({
            filters,
            populate: {
                backgroundImage: { populate: '*' },
                schoolLogo: { populate: '*' },
                featuresLogo: { populate: '*' },
                features: { populate: '*' },
                howItWorksImage: { populate: '*' },
                howItWorksSteps: { populate: '*' },
                testimonials: { populate: '*' },
                call_to_actions: { populate: '*' },
            }
        });
        const response = await CmsService.get(`housings?${query}`);

        return response?.data?.data || null;
    }
}

export default SiteService

export { SiteService }
